import React from 'react';
import Hero from '../components/Hero'
import ServicesRoot from '../components/ServicesRoot';
import PoweredByMotionode from '../components/PoweredByMotionode';
import OurClients from '../components/OurClients';
import Testimonials from '../components/Testimonials';
import ArticlesEventsCases from '../components/ArticlesEventsCases';
import MainCase from '../components/MainCase';
import Newsletter from '../components/Newsletter';
import SuccessfulCollaborations from '../components/SuccessfulCollaborations';
import ContactUs from '../components/ContactUs';

import TransitionPage from '../utils/TransitionPage';

import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>AI-Assisted Software Maintenance | Advante Digital</title>
        <meta name="description" content="Advante Digital helps companies maintain, modernize, and improve existing software using AI-assisted engineering, human QA, staging, pull requests, and controlled deployment powered by Motionode."/>
        <meta name='keywords' content='AI-assisted software maintenance, software modernization, legacy platform modernization, backlog acceleration, human QA, staging, pull requests, controlled deployment, Motionode, Stripe, marketplaces, admin systems'/>
      </Helmet>

        <Hero />
        <ServicesRoot />
        <PoweredByMotionode />
        <OurClients />
        <Testimonials />
        <ArticlesEventsCases />
        <Newsletter />
        <SuccessfulCollaborations />
        <ContactUs 
          underline = "var(--gradient-blue-violet-pink)"
          wrapperBox
          sendColor = "var(--gradient-blue-violet-pink)"
          checkColor = "var(--light-purple)"
          bgCircles = {[
            {
              color:"var(--green-mint)",
              size:"32.5rem",
              top:"-10%",
              right:"10%",
            },
            {
              color:"var(--vivid-purple)",
              size:"32.5rem",
              top:"-10%",
              left:"-10%",
              right:"auto",
            },
            {
              color:"var(--azure-blue)",
              size:"32.5rem",
              bottom:"-20%",
              right:"40%",
            }
          ]}
        />
    </>
  );
}

export default TransitionPage( Home );